import { useContext, useEffect, useReducer } from 'react';

import { LazyBackground } from '@/components/PreSignupFlow/Components/LazyBackground/types';
import { PreSignupFlowContext } from '@/components/PreSignupFlow/PreSignupProvider';

function reducer(
	state: LazyBackground[],
	action: { bgSet: LazyBackground[]; activeScreen: string },
): LazyBackground[] {
	const { bgSet, activeScreen } = action;
	const newBg = bgSet.filter(bg => bg.loadScreen === activeScreen);
	if (newBg.length === 0) {
		return state;
	}

	const nextBackgrounds = [...state, ...newBg];
	return [...new Set(nextBackgrounds)];
}

export function useLazyBackgrounds(bgSet: LazyBackground[]): LazyBackground[] {
	const { activeScreenKey: activeScreen, activeFlowKey } = useContext(PreSignupFlowContext);
	const [lazyBackgrounds, setLazyBackgrounds] = useReducer(reducer, []);

	useEffect(
		() => {
			setLazyBackgrounds({ activeScreen, bgSet });
		}, // TODO [WEB-1595]: Fix this exhaustive-deps issue
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[activeScreen, activeFlowKey],
	);

	return lazyBackgrounds;
}
